import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Email } from '../email';
import { EmailService } from '../email.service';
import { Subject } from '../subject';
import { NgForm } from '@angular/forms';

// definir "grecaptcha" como uma propriedade de "window" para que o angular não logue erro indevidamente
declare global {
  interface Window { grecaptcha: any; }
}
declare var grecaptcha: any;

@Component({
  selector: 'app-email-form',
  templateUrl: './email-form.component.html',
  styleUrls: ['./email-form.component.css']
})
export class EmailFormComponent implements OnInit {
  @ViewChild('emailForm')
  public formData: NgForm;
  captchaKey: string;
  emailSuccess?: boolean;
  subjects: Subject[];
  invalidForm: boolean;
  email: Email = {
    name: '',
    from: '',
    subject: -1,
    message: '',
    captcha: '',
    checkedRecaptcha: false
  };
  sendingEmail = false;

  constructor(private emailService: EmailService, private changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.emailService.getSubjects().subscribe(resp => {
      this.subjects = resp;
    },
    err => {
      this.invalidForm = true;
      this.changeDetector.detectChanges();
    });

    this.emailService.getRecaptchaKey().subscribe(resp => {
      this.captchaKey = resp;
      this.renderRecaptcha();
    },
    err => {
      this.invalidForm = true;
      this.changeDetector.detectChanges();
    });
  }

  renderRecaptcha() {
    const renderInterval = setInterval(() => {
      if (grecaptcha.render) {
        grecaptcha.render('emailRecaptcha', {
          sitekey: this.captchaKey,
          callback: () => { this.validateCheckedRecaptcha(); },
          'expired-callback': () => { this.expireCaptcha(); }
        });
        clearInterval(renderInterval);
      }
    }, 250);
  }

  sendMail() {
    this.sendingEmail = true;
    this.email.captcha = grecaptcha.getResponse();
    this.emailService.sendEmail(this.email).subscribe((resp: boolean) => {
      this.sendingEmail = false;
      this.emailSuccess = resp;
      this.clearFields();
    },
    () => {
      this.sendingEmail = false;
      this.emailSuccess = false;
      this.clearFields();
    });
  }

  validateCheckedRecaptcha() {
    this.email.checkedRecaptcha = true;
    if (this.formData.valid && this.formData.controls.subject.value !== -1) {
      document.getElementById('emailSubmit').removeAttribute('disabled');
    }
  }

  expireCaptcha() {
    this.email.checkedRecaptcha = false;
    document.getElementById('emailSubmit').setAttribute('disabled', '');
  }

  trimField(field: { name: string | number; model: { trim: () => void; }; }) {
    this.email[field.name] = field.model.trim();
  }

  clearFields() {
    this.email = {
      captcha: '',
      from: '',
      message: '',
      name: '',
      subject: -1,
      checkedRecaptcha: false
    };
  }
}
